import {TERM_VER} from '../../configures/val.js';
function getLatestTermVer() {
  const dateStr = new Date().toGMTString();
  const paramObj = {
    ver: TERM_VER,
    date: dateStr
  };
  return JSON.stringify(paramObj);
}
export default getLatestTermVer;
